<template>
    <div class="py-24 sm:py-32">
        <slot></slot>
    </div>
</template>
